import CopyCellRenderer from 'components/tables/AGGrid/CustomCells/CopyCellRenderer';

import CountryFlag from 'components/icons/CountryFlag';
import { tableFlagStyle } from 'components/icons/countryFlagStyles';

const NumberCellRenderer = ({ value, valueFormatted, countries, params }) => {
    const currentCountry = countries?.find(
        (country) =>
            country.id === params.data.countryID ||
            country.id === params.data.countryCodeID,
    );
    const leftAdornment = (
        <CountryFlag
            countryCode={currentCountry?.alpha2}
            title={currentCountry?.name}
            style={tableFlagStyle}
        />
    );
    return (
        <CopyCellRenderer
            value={value}
            valueFormatted={valueFormatted}
            leftAdornment={currentCountry ? leftAdornment : null}
        />
    );
};

export default NumberCellRenderer;
